import { MathUtils, Point } from '@printu/geom';
import { createLineMarker, createPolylineMarker, } from 'app/core/markers/models';
import { getExtremasBounds, getPointsExtremas } from 'app/core/markers/utils';
import { ProjectActions } from 'app/stores/project/actions';
import { getInsertStyle } from 'app/stores/selectors';
const pointAreEqual = (point1, point2) => Point.equal(point1, point2) ||
    MathUtils.equalWithEps(Point.distance(point1, point2), 1);
export const InsertPolyline = () => (dispatch, getState) => {
    const state = getState();
    const { size, color, sizeFactor, viewportZoom: _zoom, } = getInsertStyle(state);
    let marker;
    const points = [];
    const onDragStart = (payload, point) => {
        var _a, _b;
        if (marker) {
            return;
        }
        // we need to insert marker
        points.splice(0, points.length);
        points.push({ x: 0, y: 0 });
        marker = createPolylineMarker({
            x: point.x,
            y: point.y,
            points: [...points],
        });
        payload.itemId = marker.id;
        const markerSize = (_a = marker.size) !== null && _a !== void 0 ? _a : size;
        marker.size = markerSize / sizeFactor;
        const markerColor = (_b = marker.color) !== null && _b !== void 0 ? _b : color;
        marker.color = markerColor;
        dispatch(ProjectActions.itemInsert({
            marker,
            undoable: true,
        }));
    };
    const onDrag = (payload, point) => {
        const { itemId: id, down } = payload;
        if (id) {
            const vec = new Point(point.x - down.x, point.y - down.y);
            const lastIndex = points.length - 1;
            points[lastIndex] = vec.toObject();
            dispatch(ProjectActions.itemUpdate({
                id,
                patch: {
                    points: [...points],
                },
                undoable: false,
            }));
        }
    };
    const onDragEnd = payload => {
        const { itemId: id } = payload;
        if (!id) {
            return;
        }
        const lastIndex = points.length - 1;
        const lastPoint = points[lastIndex];
        points.push(Object.assign({}, lastPoint));
        dispatch(ProjectActions.itemUpdate({
            id,
            patch: {
                points: [...points],
            },
            undoable: false,
        }));
    };
    const onEnd = payload => {
        const { itemId: id } = payload;
        if (!id) {
            return;
        }
        // remove last point (drag point/mouse point)
        points.pop();
        // remove from end last if too close
        while (points.length > 1) {
            const lastPoint = points[points.length - 1];
            const secondLastPoint = points[points.length - 2];
            if (pointAreEqual(lastPoint, secondLastPoint)) {
                points.pop();
            }
            else {
                break;
            }
        }
        // no points just igore this marker
        if (points.length < 1) {
            dispatch(ProjectActions.deleteItems({ ids: [id] }));
            return;
        }
        // for one segment replace it with line
        if (points.length <= 2) {
            // replace with line
            dispatch(ProjectActions.deleteItems({ ids: [id] }));
            // try to create a line for optimization
            const lastPoint = points.pop();
            if (lastPoint) {
                const endPoint = {
                    x: marker.x + lastPoint.x,
                    y: marker.y + lastPoint.y,
                };
                // if its not a point create a line
                if (!pointAreEqual(marker, endPoint)) {
                    const line = createLineMarker({
                        x: marker.x,
                        y: marker.y,
                        endX: lastPoint.x,
                        endY: lastPoint.y,
                        size: marker.size,
                        color: marker.color,
                    });
                    dispatch(ProjectActions.itemInsert({
                        marker: line,
                        undoable: false,
                    }));
                }
            }
            return;
        }
        dispatch(ProjectActions.itemUpdate({
            id,
            patch: {
                bbox: getExtremasBounds(getPointsExtremas(points)),
                points: [...points],
            },
            undoable: false,
        }));
    };
    return {
        onPointerDown: onDragStart,
        onPointerDrag: onDrag,
        onPointerUp: onDragEnd,
        onEnd,
        payload: { path: points },
        disposeOnRelease: false,
    };
};
